import { Image, Slider, Typography } from "antd";
import foster from "../../assets/images/sean-foster-R-m3p7k9moU-unsplash.jpg";
import wegener from "../../assets/images/bill-wegener-hs98_9hzTcU-unsplash.jpg";
import "./styles.less";

const { Title, Paragraph } = Typography;

const ProjectOnGoingTabDescription = () => {
  return (
    <section className="project-on-going-tab-description">
      <Title level={2}>Introduction</Title>
      <Paragraph>
        L'association Ataajy est dédiée à la réinsertion des enfants en
        difficulté. Nous croyons fermement en la dignité, l'éducation et le
        bien-être de chaque enfant. C'est la raison pour laquelle nous avons
        décidé de construire un biodigesteur afin de produire du gaz naturel. Ce
        projet humanitaire vise à soutenir le Centre Évangélique de Réinsertion
        des Enfants de Ntolo.
      </Paragraph>
      <Title level={2}>Financement</Title>
      <Paragraph>
        Somme recoltée: <span className="amount">914 €</span> /{" "}
        <span className="total">3.658 € (2.400.000 F CFA)</span>
      </Paragraph>

      <Paragraph>
        <Slider
          value={25}
          tooltip={{
            formatter: (value) => {
              return `${value}%`;
            },
          }}
        />
      </Paragraph>
      <Paragraph>
        Vous pouvez nous aider à réaliser ce projet en faisant un virement sur
        le compte de l'association
      </Paragraph>
      <Paragraph>
        Ataajy asbl
        <br />
        IBAN: <b>LU17 1111 7055 5877 0000</b>
        <br />
        BIC: <b>CCPL LULL</b>
      </Paragraph>
      <Paragraph>
        N'oubliez pas d'indiquer un motif du virement. Exemple: Biodigesteur
        Ntolo - monemail@gmail.com
      </Paragraph>
      <Title level={2}>Contexte</Title>
      <Paragraph>
        <Image src={foster} />
      </Paragraph>
      <Paragraph>
        Le Centre Évangélique de Réinsertion des Enfants de Ntolo, situé dans un
        village avec des ressources limitées, a entrepris l'élevage de porcs
        comme moyen de subsistance. Ce projet est essentiel pour fournir une
        alimentation régulière et équilibrée aux 20 enfants et au personnel du
        centre.
      </Paragraph>
      <Title level={2}>Objectifs du Projet</Title>
      <Paragraph>Les objectifs spécifiques de ce projet sont :</Paragraph>
      <Paragraph>
        <ol>
          <li>
            Produire du gaz naturel pour cuisiner : Utiliser les déchets
            organiques des porcs et des toilettes du centre pour produire du
            biogaz, réduisant ainsi les coûts de cuisson.
          </li>
          <li>
            Produire de l'électricité pour le centre : Convertir une partie du
            gaz produit en électricité. Ceci fournira un éclairage adéquat aux
            personnes au centre et aussi plus de sécurité
          </li>
          <li>
            Utiliser les fertilisants issus du biodigesteur dans les champs
            environnants afin d'augmenter la quantité et la qualité des
            récoltes.
          </li>
          <li>
            Améliorer la qualité de vie des habitants du centre avec de
            l'énergie pas cher, un lieu de vie plus propre grâce au recyclage et
            plus de nourriture grâce au fertilisant qui augmentera la production
            des champs.
          </li>
        </ol>
      </Paragraph>
      <Title level={2}>Méthodologie</Title>
      <Paragraph>Pour atteindre nos objectifs, nous allons :</Paragraph>
      <Paragraph>
        <ul>
          <li>
            Étape 1 : Installer un biodigesteur de 25 m³ pour transformer les
            déchets organiques en biogaz.
          </li>
          <li>
            Étape 2 : Mettre en place un générateur qui convertira le biogaz en
            électricité.
          </li>
          <li>
            Étape 3 : Former le personnel et les enfants à l'utilisation et à
            l'entretien des équipements.
          </li>
          <li>
            Étape 4 : Établir des partenariats avec des entreprises locales pour
            la vente des produits dérivés.
          </li>
        </ul>
      </Paragraph>
      <Title level={2}>Bénéficiaires</Title>
      <Paragraph>
        <Image src={wegener} />
      </Paragraph>
      <Paragraph>Les principaux bénéficiaires de ce projet seront :</Paragraph>
      <Paragraph>
        <ul>
          <li>
            Les enfants et le personnel du Centre Évangélique de Réinsertion des
            Enfants de Ntolo.
          </li>
          <li>
            Le voisinage direct du centre, qui bénéficiera de l'électricité
            produite et des fertilisants.
          </li>
        </ul>
      </Paragraph>
      <Title level={2}>Partenariats et Collaborations</Title>
      <Paragraph>
        Nous collaborons avec l'entreprise <b>Green Power Biotechnology</b> pour
        assurer la réussite de ce projet.
      </Paragraph>
      <Title level={2}>Budget</Title>
      <Paragraph>
        Le budget total nécessaire pour ce projet est de 3.658,77 € (2.400.000
        FCFA). Ce budget couvrira :
      </Paragraph>
      <Paragraph>
        <ul>
          <li>
            Phase 1 - Construction du gazomètre et coulage du dôme : 1.500 €
            (1.000.000 F CFA)
          </li>
          <li>
            Phase 2 - Construction du bac de compensation : 1.295 € (850.000
            FCFA)
          </li>
          <li>
            Phase 3 - Canalisation et mise en place des suppresseurs : 838 €
            (550.000 FCFA)
          </li>
        </ul>
      </Paragraph>
      <Title level={2}>Impact Attendu</Title>
      <Paragraph>
        Nous prévoyons que ce projet aura les impacts suivants :
      </Paragraph>
      <Paragraph>
        <ul>
          <li>
            Le biodigesteur permet de réduire la pollution liée aux déchets
            organiques (déjections animales et humaines, ordures). Ceci améliore
            l’hygiène publique et limite la prolifération de maladies liées à la
            contamination de l’eau et des sols.
          </li>
          <li>
            L'utilisation du gaz naturel issu du biodigesteur comme source
            d'énergie pour la cuisson réduit l’exposition aux fumées toxiques du
            bois ou du charbon, ce qui diminue les problèmes respiratoires,
            notamment chez les femmes et les enfants.
          </li>
          <li>
            Les effluents du biodigesteur sont utilisés comme fertilisants
            naturels et biologiques, permettant de remplacer les engrais
            chimiques. Cela enrichit les sols, augmente les rendements agricoles
            et contribue à la sécurité alimentaire locale.
          </li>
          <li>
            L’amélioration de la fertilité des sols favorise la régénération de
            terres agricoles appauvries ou abandonnées, favorisant ainsi
            l’autonomie des populations rurales.
          </li>
          <li>
            La production de gaz naturel domestique et de fertilisants amène une
            baisse des dépenses en énergie et en engrais, permettant aux foyers
            d’allouer leur budget à d’autres besoins essentiels.
          </li>
          <li>
            Le biodigesteur crée des vocations issues de sa gestion, son
            entretien et la valorisation des produits issus du processus de
            méthanisation. Cette diversification des activités économiques peut
            réduire l’exode rural et renforcer la cohésion de la communauté.
          </li>
        </ul>
      </Paragraph>
      <Title level={2}>Conclusion</Title>
      <Paragraph>
        Nous sommes convaincus que ce projet humanitaire contribuera
        significativement à améliorer les conditions de vie des enfants et du
        personnel du Centre Évangélique de Réinsertion des Enfants de Ntolo,
        ainsi que celles des familles voisines. Nous invitons tous ceux qui
        partagent notre vision à nous soutenir dans cette initiative.
      </Paragraph>
    </section>
  );
};

export default ProjectOnGoingTabDescription;
